export const AUTH_REGISTER = "AUTH_REGISTER";
export const AUTH_VERIFY_ACCOUNT = "AUTH_VERIFY_ACCOUNT";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGIN_GG = "AUTH_LOGIN_GG";
export const AUTH_LOGIN_FB = "AUTH_LOGIN_FB";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_CHANGE_PASSWORD = "AUTH_CHANGE_PASSWORD";
export const AUTH_FORGOT_PASSWORD = "AUTH_FORGOT_PASSWORD";
export const AUTH_RESET_PASSWORD = "AUTH_RESET_PASSWORD";

